(function () {
  const DRAWER_SEL = '[data-collection-sort-drawer]';
  const OPEN_SEL = '[data-collection-sort-open]';
  const CLOSE_SEL = '[data-collection-sort-drawer-close]';
  const PANEL_SEL = '[data-collection-sort-drawer-panel]';
  const RADIO_SEL = '[data-collection-sort-radio]';

  let lastFocus = null;

  function getOpenButtons() {
    return document.querySelectorAll(OPEN_SEL);
  }

  function isOpen(root) {
    return root?.classList.contains('is-open');
  }

  function openDrawer(root) {
    const panel = root.querySelector(PANEL_SEL);
    const form = root.closest('form');
    const openBtn = form?.querySelector(OPEN_SEL);
    if (!root || !panel) return;

    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    openBtn?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('collection-sort-drawer-open');
    document.body.style.overflow = 'hidden';

    lastFocus = document.activeElement;
    panel.focus({ preventScroll: true });
  }

  function closeDrawer(root) {
    const form = root?.closest('form');
    const openBtn = form?.querySelector(OPEN_SEL);
    if (!root) return;

    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    openBtn?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('collection-sort-drawer-open');
    document.body.style.overflow = '';

    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  function closeAllDrawers() {
    document.querySelectorAll(DRAWER_SEL).forEach(function (root) {
      if (isOpen(root)) closeDrawer(root);
    });
  }

  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest(OPEN_SEL);
    if (openBtn) {
      e.preventDefault();
      const form = openBtn.closest('form');
      const root = form?.querySelector(DRAWER_SEL);
      if (!root) return;
      if (isOpen(root)) {
        closeDrawer(root);
      } else {
        closeAllDrawers();
        openDrawer(root);
      }
      return;
    }

    const closeEl = e.target.closest(CLOSE_SEL);
    if (closeEl) {
      const root = closeEl.closest(DRAWER_SEL);
      if (root && isOpen(root)) {
        e.preventDefault();
        closeDrawer(root);
      }
    }
  });

  document.addEventListener('change', function (e) {
    const radio = e.target.closest(RADIO_SEL);
    if (!radio) return;
    const form = radio.closest('form');
    if (form) form.submit();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(DRAWER_SEL).forEach(function (root) {
      if (isOpen(root)) {
        e.preventDefault();
        closeDrawer(root);
      }
    });
  });
})();
